<template>
  <h3 v-html="text.creditLineGrowthTitle"></h3>
  <div class="growth-chart-wrapper">
  <LineChart ref="creditChartRef" :chartData="growthData" :options="growthOptions"  />
  </div>
  <p class="chart-disclaimer"><small v-html="text.creditLineGrowthFooter"></small></p>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue'
import { LineChart } from 'vue-chart-3'
import { Chart, registerables } from 'chart.js'
import { growthOptionsVar } from '../inc/growthChart.js'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'

Chart.register(...registerables, ChartJsPluginDataLabels)

export default defineComponent({
  name: 'CreditGrowthChart',
  props: {
    growthData: Object,
    product: Object,
    textStrings: Object
  },
  components: { LineChart },
  setup (props) {
    const growthOptions = growthOptionsVar
    const creditChartRef = ref()
    onMounted(() => {
      if (window.innerWidth < 768) {
        creditChartRef.value.chartInstance.options.plugins.datalabels.display = false
      } else {
        creditChartRef.value.chartInstance.options.plugins.datalabels.display = true
      }
      creditChartRef.value.chartInstance.update()
      creditChartRef.value.chartInstance.resize()
    })
    return { growthOptions, creditChartRef }
  },
  data () {
    return {
      text: this.textStrings[this.product.id]
    }
  },
  created () {
    globalThis.addEventListener('resize', this.resizeCharts)
  },
  unMounted () {
    globalThis.removeEventListener('resize', this.resizeCharts)
  },
  methods: {
    resizeCharts (e) {
      if (window.innerWidth < 768) {
        this.$refs.creditChartRef.chartInstance.options.plugins.datalabels.display = false
      } else {
        this.$refs.creditChartRef.chartInstance.options.plugins.datalabels.display = true
      }
      this.$refs.creditChartRef.chartInstance.update()
      this.$refs.creditChartRef.chartInstance.resize()
    }
  }

})
</script>
